export default "__VITE_ASSET__DZCQwRj3__$_?height=200&width=300__"